export default {
  data: () => ({
    translations: {
      addStore: {
        el: 'Προσθήκη Καταστήματος',
        en: 'Add Store',
        it: 'Add Store',
      },
      rights: {
        el: '',
        en: 'Rights',
        it: '',
      },
      name: {
        el: 'Όνομα',
        en: 'Name',
        it: 'Nome',
      },
      storeName: {
        el: 'Όνομα Καταστήματος (στην εφαρμογή)',
        en: 'Name of Store(in app)',
        it: "Nome del negozio (nell'app)",
      },
      customer: {
        el: 'Πελάτες',
        en: 'Customer',
        it: 'Cliente',
      },
      transaction: {
        el: 'Συναλλαγές',
        en: 'Transaction',
        it: 'Transazione',
      },
      income: {
        el: 'Τζίρος',
        en: 'Income',
        it: 'Fatturato',
      },
      points: {
        el: 'Πόντοι',
        en: 'Points',
        it: 'Punti',
      },
      cashback: {
        el: 'Cashback',
        en: 'Cashback',
        it: 'Cashback',
      },
      paginationText: {
        el: 'από',
        en: 'of',
        it: 'di',
      },
    },
  }),
};
